/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface FormTrackSeenResource
 */
export interface FormTrackSeenResource {
    /**
     * restrict scope to a single block (optional)
     * @type {string}
     * @memberof FormTrackSeenResource
     */
    block?: FormTrackSeenResourceBlockEnum;
    /**
     * restrict scope to a single question (optional)
     * @type {string}
     * @memberof FormTrackSeenResource
     */
    question_id?: string;
    /**
     * mark form as read/unread (optional)
     * @type {boolean}
     * @memberof FormTrackSeenResource
     */
    read?: boolean;
}




/**
* @export
* @enum {string}
*/
export enum FormTrackSeenResourceBlockEnum {
    Attachments = 'attachments',
    Comments = 'comments',
    SscData = 'ssc_data',
    History = 'history',
    All = 'all'
}


